import CustomMenuList from '@/components/Form/Select/CustomMenuList'
import CustomOption from '@/components/Form/Select/CustomOption'
import { isNullish } from '@/utils/helper'
import React from 'react'
import ReactSelect, { createFilter } from 'react-select'

const UncontrolledMultiSelect = ({ options, value, disabled = false, onChange }) => {
  const valueAsArray = Array.isArray(value) ? value : [value].filter((val) => val !== '' && !isNullish(val))
  const currentOptionValues = options.map((opt) => opt.value)

  const currentOptionsContainAllValues =
    valueAsArray.every((value) => currentOptionValues.includes(value)) ||
    currentOptionValues.length < valueAsArray.length

  const selectedOptions = valueAsArray
    .map((val) => {
      const selectedOption = options.find((opt) => opt.value === val)
      return selectedOption
    })
    .filter((opt) => !isNullish(opt))

  return (
    <ReactSelect
      isMulti={true}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        container: (base) => ({
          ...base,
          flex: 1,
          width: '100%',
        }),
        control: (base, { isDisabled }) => {
          let bgColor = 'white'
          if (isDisabled) {
            bgColor = 'hsl(0, 0%, 95%)'
          }
          return {
            ...base,
            backgroundColor: bgColor,
            borderColor: '#E2E8F0',
          }
        },
        singleValue: (base) => ({
          ...base,
          color: 'hsl(0, 0%, 50%)',
        }),
        multiValueRemove: (base, state) => {
          return state.isDisabled ? { ...base, display: 'none' } : base
        },
      }}
      filterOption={createFilter({ ignoreAccents: false })}
      options={options}
      value={selectedOptions}
      onChange={(selectedOptions) => {
        if (!selectedOptions || selectedOptions === null) {
          onChange('')
        } else {
          onChange(selectedOptions.map((v) => v.value))
        }
      }}
      onFocus={() => {
        const errorElement = document.getElementById(name)
        if (errorElement) {
          errorElement.scrollIntoView({
            behavior: `smooth`,
            block: 'center',
          })
        }
      }}
      components={{
        Option: CustomOption,
        MenuList: CustomMenuList,
      }}
      isDisabled={disabled}
      isClearable={!disabled}
      menuPortalTarget={document.body}
    />
  )
}

export default UncontrolledMultiSelect
